import React from 'react';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface DropoutAnalysisTableProps {
  dropOutData: { page: string | number; count: number }[];
}

const DropoutAnalysisTable: React.FC<DropoutAnalysisTableProps> = ({
  dropOutData,
}) => (
  <DashboardChartBox>
    <div
      style={{
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
      }}
    >
      <HeaderTitle>
        <p>Drop-out Analysis</p>
      </HeaderTitle>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="styled-table">
          <thead>
            <tr>
              <th>Last Completed Page</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {dropOutData.map((drop, index) => (
              <tr key={index}>
                <td>{drop.page}</td>
                <td>{drop.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </DashboardChartBox>
);

export default DropoutAnalysisTable;
